import React, { Component } from 'react';
import Loader from "../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Footer from "../../common_components/Footer";
import Header from "../../common_components/Header";
import { withRouter } from "../../utils/withRouter";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ReactDOM from 'react-dom';
import { Carousel } from 'react-responsive-carousel'
import { connect } from "react-redux";
import $ from "jquery";
import { Modal } from "react-bootstrap";
import moment from 'moment';
import { countDownDate_action } from '../../actions/staticAction/static_action';
import { BASE_URL, sessionExpireMessage, toastError, tokenInavlidMessage } from '../../utils/constants';
import { getWebsiteBlogList_action } from '../../actions/staticAction/static_action'
import purify from 'dompurify'
import { get_eventMaster_list_action } from '../../actions/adminAction/event_master_action';
import { getCmsContent_action } from "../../actions/cms_action/cmsAction";
import SiteMaintenance from '../../common_components/siteMaintenance';

class Homepage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isSiteMaintenance: false,
            eventMasterList: [],
            downloadUrl: '',
            slideList: [
                {
                    imgSrc: "assets/img/Upcoming_Events/itmeawardlogo.jpg",
                    title: "ITME-AWARDS",
                    titleDetails: "India ITME Technical Awards aims to encourage high performance & competitive edge in textile engineering field.",
                    isActive: false,
                    date: '20',
                    month: 'MAY',
                    startAndEndDate: '21st Feb - 31st July 2025',
                    location: 'India ITME Society, Nariman Point, Mumbai, India',
                    link: 'https://awards.india-itme.com'
                },
                {
                    imgSrc: "assets/img/Upcoming_Events/gttes2025.png",
                    title: "GTTES-2025",
                    titleDetails: "GTTES 2025 will showcase cutting-edge advancements and opportunities, redefining global textile innovation.",
                    isActive: true,
                    date: '26',
                    month: 'JUNE',
                    startAndEndDate: '21st - 23rd Feb 2025',
                    location: 'Bombay Convention & Exhibition Centre, Mumbai, India',
                    link: 'https://corporate.india-itme.com/gttes2025/'
                },
                {
                    imgSrc: "assets/img/Upcoming_Events/2026eventlogo.jpg",
                    title: "ITME-2026",
                    titleDetails: "12th Edition of India ITME is scheduled from 3rd to 8th December 2026 at India Exposition Mart Ltd, Noida.",
                    isActive: false,
                    date: '28',
                    month: 'AUG',
                    startAndEndDate: '04th - 09th DEC 2026',
                    location: 'Greater Noida, Uttar Pradesh',
                    link: 'https://corporate.india-itme.com/itme2026/'
                },
            ],
            whyAttendList: [
                { imgSrc: "https://www.indiadigitalsummit.in/wp-content/themes/IDS/assets/images/why-attend/masterclass.png", title: `Workshops & Masterclasses`, hover: `The Workshops &amp; Masterclasses at IDS25 will offer hands-on, in-depth sessions led by industry experts, focusing on practical applications of emerging technologies. Participate and explore opportunities on emerging technologies like AI, blockchain, quantum computing, and sectoral topics.` },
                { imgSrc: "https://www.indiadigitalsummit.in/wp-content/themes/IDS/assets/images/why-attend/img-2.png", title: `Closed Room Sessions`, hover: `Join Policy &amp; Regulatory Closed Room Sessions to delve into key regulatory issues and contribute to shaping future digital policies.` },
                { imgSrc: "https://www.indiadigitalsummit.in/wp-content/themes/IDS/assets/images/why-attend/startups.png", title: `Startup Pitches`, hover: `Discover and support innovative startups as they present their business ideas to potential investors and partners.` },
                { imgSrc: "https://www.indiadigitalsummit.in/wp-content/themes/IDS/assets/images/why-attend/industry-awards.png", title: 'Industry Awards', hover: `Celebrate achievements and excellence in digital innovation at the India Digital Awards &amp; Digital Responsibility Awards.` },
                { imgSrc: "https://www.indiadigitalsummit.in/wp-content/themes/IDS/assets/images/why-attend/sundowner.png", title: `Sundowners`, hover: `Sundowners at IDS25 provide a networking environment, ideal for creating connections and sparking conversations over casual conversation with industry leaders.` },
                { imgSrc: "https://www.indiadigitalsummit.in/wp-content/themes/IDS/assets/images/why-attend/nightfest.png", title: `Night Fest`, hover: `The Night Fest at IDS25 is a vibrant celebration where attendees can unwind and enjoy an evening of cultural performances, entertainment, and informal networking, blending business with leisure in a lively atmosphere.` },
                { imgSrc: "https://www.indiadigitalsummit.in/wp-content/themes/IDS/assets/images/why-attend/leading-speakers.png", title: `Insights from Leading Speakers`, hover: `Attend keynotes, fireside chats and panel discussions featuring regulators, policymakers, CXOs, founders, and industry experts.` },
                { imgSrc: "https://www.indiadigitalsummit.in/wp-content/themes/IDS/assets/images/why-attend/ceo-dinner.png", title: `CXO Dinner`, hover: `This exclusive networking gathering for industry leaders and policymakers provides a high-level networking opportunity. Engage with decision-makers and influencers during targeted networking gatherings.` },
                { imgSrc: "https://www.indiadigitalsummit.in/wp-content/themes/IDS/assets/images/why-attend/report-launch.png", title: `Research Report`, hover: `Engage with decision-makers and influencers during targeted networking sessions. Stay ahead of industry trends with insights into the latest market developments and technological advancements.` },
                { imgSrc: "https://www.indiadigitalsummit.in/wp-content/themes/IDS/assets/images/why-attend/showcases.png", title: `Product Launches & Showcases`, hover: `IDS25 will unveil cutting-edge solutions and breakthrough innovations across sectors and get first-hand experience of the latest products. Witness more than 20 Product Launches and showcases at the event.` },
                { imgSrc: "https://www.indiadigitalsummit.in/wp-content/themes/IDS/assets/images/why-attend/leadership-roundtable.png", title: `Leadership Roundtables`, hover: `IDS25 will bring together C-level executives, policymakers, and thought leaders for candid discussions on the challenges and opportunities in driving digital transformation.` },
                { imgSrc: "https://www.indiadigitalsummit.in/wp-content/themes/IDS/assets/images/why-attend/ask-me-anything.png", title: `Founders’ opportunity to engage directly with industry experts, innovators, and policymakers.` },

            ],
            teamList: [
                { imgSrc: "assets/img/team/01.jpg", name: "Ronel Smith", designation: 'UX Deginer' },
                { imgSrc: "assets/img/team/01.jpg", name: "Ronel Smith", designation: 'UX Deginer' },
                { imgSrc: "assets/img/team/01.jpg", name: "Ronel Smith", designation: 'UX Deginer' },
                { imgSrc: "assets/img/team/01.jpg", name: "Ronel Smith", designation: 'UX Deginer' },
                { imgSrc: "assets/img/team/01.jpg", name: "Ronel Smith", designation: 'UX Deginer' },
                { imgSrc: "assets/img/team/01.jpg", name: "Ronel Smith", designation: 'UX Deginer' },
            ],
            guestReviewsList: [
                { imgSrc: "assets/img/testimonial/02.jpg", name: "Gordon Novak", designation: 'Our Guest', review: 'There are many variations of passage available the majority have suffered to alteration in some form making it look like readable by injected humour.' },
                { imgSrc: "assets/img/testimonial/02.jpg", name: "Gordon Novak", designation: 'Our Guest', review: 'There are many variations of passage available the majority have suffered to alteration in some form making it look like readable by injected humour.' },
                { imgSrc: "assets/img/testimonial/02.jpg", name: "Gordon Novak", designation: 'Our Guest', review: 'There are many variations of passage available the majority have suffered to alteration in some form making it look like readable by injected humour.' },
                { imgSrc: "assets/img/testimonial/02.jpg", name: "Gordon Novak", designation: 'Our Guest', review: 'There are many variations of passage available the majority have suffered to alteration in some form making it look like readable by injected humour.' },
                { imgSrc: "assets/img/testimonial/02.jpg", name: "Gordon Novak", designation: 'Our Guest', review: 'There are many variations of passage available the majority have suffered to alteration in some form making it look like readable by injected humour.' },
            ],
            ServiceRelated: 'Trade_Missions',
            isCommingSoon: false,
            isOpen: false,
            timeLeft: {},
            intervalId: null,
            popMsg: null,
            popDetails: {},
            blogList: [],
            isSocial: false,
            htmlBlogContent: '',
            //cms
            cmsSectionData: [],
            MenuID: '', MenuUrl: '',
            cmsMenuData: [], cmsFooterData: [],
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
        sessionStorage.setItem("currentPage", 'index')
        const sortUrl = BASE_URL.split("/api");
        this.setState({ downloadUrl: sortUrl[0] });

        if (this.props.location.pathname == '/') {
            this.setState({ MenuUrl: 'home', MenuID: 1, cmsMenuData: [] }, () => {
                this.getCmsContent(1, 'home');
                this.getBlogList()
                this.getEventMasterList()

            });
            return
        }

        const urlHash = this.props.location.pathname;
        console.log(this.props.location, 'did');


        if (urlHash) {
            const parts = urlHash.split('&');

            if (parts.length === 2) {
                const MenuUrl = parts[0];
                const MenuID = parts[1];

                console.log("Menu URL:", MenuUrl);
                console.log("Menu ID:", MenuID);

                this.setState({ MenuUrl: MenuUrl ? MenuUrl : 'home', MenuID: MenuID ? MenuID : 1, cmsMenuData: [] }, () => {
                    this.getCmsContent(MenuID ? MenuID : 1, MenuUrl ? MenuUrl : 'home');
                    this.getBlogList()
                    this.getEventMasterList()

                });

            }
        }


    }
    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            const urlHash = this.props.location.pathname;
            console.log(this.props.location, 'did');

            if (urlHash.includes('RegisteredList')) {
                window.open('#/RegisteredList', '_blank');
            } else if (urlHash.includes('companyProfile')) {
                window.open('#/companyProfile', '_blank');
            } else if (urlHash.includes('buisnessDetails')) {
                window.open('#/buisnessDetails', '_blank');
            } else if (urlHash.includes('payment')) {
                window.open('#/payment', '_blank');
            } else if (urlHash.includes('thankyou')) {
                window.open('#/thankyou', '_blank');
            } else if (urlHash.includes('enquiryForm')) {
                window.open('#/enquiryForm', '_blank');
            } else if (urlHash.includes('eventEnquiryForm')) {
                window.open('#/eventEnquiryForm', '_blank');
            } else if (urlHash == '/') {
                this.setState({ MenuUrl: 'home', MenuID: 1, cmsMenuData: [] }, () => {
                    this.getCmsContent(1, 'home')
                })
            } else {
                if (urlHash) {
                    const parts = urlHash.split('&');

                    if (parts.length === 2) {
                        const MenuUrl = parts[0];
                        const MenuID = parts[1];

                        if (MenuID === '1') {
                            window.location.reload();
                            return;
                        }

                        this.setState({ MenuUrl, MenuID, cmsMenuData: [] }, () => {
                            this.getCmsContent(MenuID, MenuUrl);
                        });
                    }
                }
            }

            console.log("URL changed to:", this.props.location.pathname);
        }
    }
    getEventMasterList() {
        const { Title } = this.state
        this.setState({ isLoading: true })
        this.props
            .get_eventMaster_list_action(Title, 1,0)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ eventMasterList: data.data });
                    setTimeout(() => {
                        this.setState({ isLoading: false });
                    }, 500);
                } else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear();
                        this.props.navigate("/");
                        setTimeout(() => {
                            toastError(data.msg);
                        }, 2000);
                    } else {
                        toastError(data.data);
                    }
                    this.setState({ isLoading: false })
                    toastError(data.data.ErrorMsg);
                }
            }).catch((e) => {
                console.log(e);
                this.setState({ isLoading: false });
            });
    }
    getBlogList() {
        const { } = this.state
        this.setState({ isLoading: true })
        this.props
            .getWebsiteBlogList_action()
            .then((data) => {
                if (data.error != 1) {
                    this.setState({
                        blogList: data?.data,
                    })
                    setTimeout(() => {
                        this.setState({ isLoading: false })
                    }, 500);
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });

    }

    getCountDownDate(navigateTo) {
        const { } = this.state
        this.setState({ isLoading: true })
        this.props
            .countDownDate_action()
            .then((data) => {
                console.log(data)
                if (data.error != 1) {
                    if (data.data != []) {
                        const LaunchDate = data.data[0]['countDownDate']
                        const targetDate = moment.utc(LaunchDate);  // Target in UTC

                        // Current date in UTC
                        const currentDate = moment();  // Current date in UTC
                        const split = currentDate.format().split('+')
                        const updateCurrentDate = split[0] + 'Z'
                        const totalSeconds = targetDate.diff(updateCurrentDate, 'seconds');

                        const array = LaunchDate != null && this.formatDate(LaunchDate);
                        if (totalSeconds >= 0) {
                            const timer = setInterval(() => {
                                this.setState({ timeLeft: this.calculateTimeLeft(LaunchDate) }, () => {
                                    sessionStorage.setItem("navigateTo", navigateTo);
                                    this.setState({ isOpen: true, isLoading: false, isCommingSoon: false, popMsg: 'registration', popDetails: array });
                                });
                            }, 1000);
                            this.setState({ intervalId: timer });
                        } else {
                            this.setState({ isCommingSoon: true, isLoading: false });
                            this.props.navigate(navigateTo);
                            if (navigateTo === '/companyProfile') {
                                sessionStorage.setItem('currentPage', 'companyProfile');
                            }
                            sessionStorage.removeItem('navigateTo');
                            this.setState({ isOpen: false });
                        }

                    } else {
                        this.setState({ isLoading: false });
                    }

                } else {
                    this.setState({ isLoading: false })
                    toastError(data.data.ErrorMsg);
                }
            })
    }

    getEnquiryDate(navigateTo) {
        const { } = this.state
        this.setState({ isLoading: true })
        this.props
            .countDownDate_action()
            .then((data) => {
                console.log(data)
                if (data.error != 1) {
                    if (data.data != []) {
                        const LaunchDate = data.data[0]['enquiryDate']
                        const targetDate = moment.utc(LaunchDate);  // Target in UTC

                        // Current date in UTC
                        const currentDate = moment();  // Current date in UTC
                        const split = currentDate.format().split('+')
                        const updateCurrentDate = split[0] + 'Z'
                        const totalSeconds = targetDate.diff(updateCurrentDate, 'seconds');

                        const array = LaunchDate != null && this.formatDate(LaunchDate);
                        if (totalSeconds >= 0) {
                            const timer = setInterval(() => {
                                this.setState({ timeLeft: this.calculateTimeLeft(LaunchDate) }, () => {
                                    sessionStorage.setItem("navigateTo", navigateTo);
                                    this.setState({ isOpen: true, isLoading: false, isCommingSoon: false, popMsg: 'enquiry', popDetails: array });
                                });
                            }, 1000);
                            this.setState({ intervalId: timer });
                        } else {
                            this.setState({ isCommingSoon: true, isLoading: false });
                            this.props.navigate(navigateTo);
                            sessionStorage.removeItem('navigateTo');
                            this.setState({ isOpen: false });
                        }

                    } else {
                        this.setState({ isLoading: false });
                    }

                } else {
                    this.setState({ isLoading: false })
                    toastError(data.data.ErrorMsg);
                }
            })
    }

    formatDate(dateString) {
        const dateObj = new Date(dateString);
        const date = dateObj.getUTCDate();
        const month = dateObj.toLocaleString('en-US', { month: 'long', timeZone: 'UTC' });
        const year = dateObj.getUTCFullYear();
        const time = dateObj.toISOString().split('T')[1].slice(0, 5);

        // Function to get ordinal suffix
        function getOrdinalSuffix(day) {
            if (day > 3 && day < 21) return "th"; // Covers 4-20
            switch (day % 10) {
                case 1: return "st";
                case 2: return "nd";
                case 3: return "rd";
                default: return "th";
            }
        }

        return {
            date,
            month,
            year,
            time,
            pronounce: getOrdinalSuffix(date)
        };
    }

    calculateTimeLeft = (LaunchDate) => {

        const targetDate = moment.utc(LaunchDate);  // Target in UTC
        // console.log("Target Date in UTC: ", targetDate.format()); 

        // Current date in UTC
        const currentDate = moment();  // Current date in UTC
        // console.log("Current Date in UTC: ", currentDate.format().split('+'));
        const split = currentDate.format().split('+')
        const updateCurrentDate = split[0] + 'Z'
        // console.log("Current Date in UTC: ", updateCurrentDate);

        // Calculate the difference between the current time and target time in total seconds
        const totalSeconds = targetDate.diff(updateCurrentDate, 'seconds');

        // Calculate the total minutes, hours, and days
        const days = Math.floor(totalSeconds / (60 * 60 * 24)); // Convert seconds to days
        const hours = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60)); // Convert remainder to hours
        const minutes = Math.floor((totalSeconds % (60 * 60)) / 60); // Convert remainder to minutes
        const seconds = totalSeconds % 60; // Remainder is the seconds

        // If the countdown reaches 0, close the modal and trigger 'handleRegisterNow'
        console.log("this.state.isOpen -->", this.state.isOpen)
        if (days == 0 && hours == 0 && minutes == 0 && seconds == 0) {
            const { intervalId } = this.state;
            if (intervalId) {
                clearInterval(intervalId); // Stop the timer
                this.setState({ intervalId: null }); // Reset the interval ID
            }
            const navigateTo = sessionStorage.getItem('navigateTo');
            if (navigateTo) {
                this.props.navigate(navigateTo);

                if (navigateTo === '/companyProfile') {
                    sessionStorage.setItem('currentPage', 'companyProfile');
                }

                sessionStorage.removeItem('navigateTo');
                this.setState({ isOpen: false });
            }

        }

        return {
            days: days < 10 ? `0${days}` : days,
            hours: hours < 10 ? `0${hours}` : hours,
            minutes: minutes < 10 ? `0${minutes}` : minutes,
            seconds: seconds < 10 ? `0${seconds}` : seconds,
        };
    };

    // handleAfterChange = (current, settings) => {
    //     const { eventMasterList } = this.state;
    //     const middleIndex = Math.floor(settings.slidesToShow / 2); // Get the middle index

    //     // Reset all slides' isActive to false
    //     eventMasterList.forEach((slide) => {
    //         slide.isActive = false;
    //     });

    //     // Calculate the new active slide index
    //     const newActiveIndex = (current + middleIndex) % eventMasterList.length;

    //     // Set the middle slide as active
    //     eventMasterList[newActiveIndex].isActive = true;

    //     // Update the state
    //     this.setState({ eventMasterList });
    // };

    handleAfterChange = (current, settings) => {
        const { slideList } = this.state;
        const middleIndex = Math.floor(settings.slidesToShow / 2); // Get the middle index

        // Reset all slides' isActive to false
        slideList.forEach((slide) => {
            slide.isActive = false;
        });

        // Calculate the new active slide index
        const newActiveIndex = (current + middleIndex) % slideList.length;

        // Set the middle slide as active
        slideList[newActiveIndex].isActive = true;

        // Update the state
        this.setState({ slideList });
    };

    handleRegisterNow() {
        this.props.navigate('/companyProfile')
        sessionStorage.setItem("currentPage", 'companyProfile')
    }
    navigateEventEnquiry(EventID, isViewFlag) {
        this.props.navigate('/eventEnquiryForm', { state: { EventID: EventID, isViewFlag: isViewFlag } })
    }

    sanitizeAndResizeImages = (htmlContent) => {
        const div = document.createElement("div");
        div.innerHTML = purify.sanitize(htmlContent);

        // Resize all images
        div.querySelectorAll("img").forEach((img) => {
            img.style.width = "450px";  // Make image responsive within the fixed box
            img.style.height = "315px"; // Maintain aspect ratio
            img.style.objectFit = "cover"; // Ensure full coverage
        });
        div.querySelectorAll("span").forEach((span) => {
            span.style.display = "inline-block";
            span.style.lineHeight = "23px";
        });

        return div.innerHTML;
    };

    shareOnWhatsApp = () => {
        const htmlString = `<p>Sagar Jogmerkar</p><img src="https://tradedesk_uat.india-itme.com/document/header-footer/email-header.png" />`;

        // Extract text & image from HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");

        const text = doc.querySelector("p")?.textContent || "";
        const imgSrc = doc.querySelector("img")?.getAttribute("src") || "";

        if (text) {
            let message = `${text}`;
            if (imgSrc) {
                message += `\n\n${imgSrc}`; // Add the image URL to the message
            }
            const whatsappUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(message)}`;
            window.open(whatsappUrl, "_blank");
        }
    };

    shareOnTwitter = () => {
        const htmlString = `<p>Sagar Jogmerkar</p><img src="https://india-itme.com/document/Exhibition/mailHeaderImage/3/mailHeaderImage3.jpeg" />`;

        // Extract text & image from HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");

        const text = doc.querySelector("p")?.textContent || "";
        const imgSrc = doc.querySelector("img")?.getAttribute("src") || "";

        if (text) {
            let message = `${text}`;
            if (imgSrc) {
                message += `\n\nImage: ${imgSrc}`; // Include the image URL
            }

            // Twitter Web Intent URL
            const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(message)}`;

            // Open Twitter Share Dialog
            window.open(twitterUrl, "_blank");
        }
    };


    shareOnFacebook = () => {
        const htmlString = `<p>Sagar Jogmerkar</p><img src="https://india-itme.com/document/Exhibition/mailHeaderImage/3/mailHeaderImage3.jpeg" />`;

        // Extract text & image from HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");

        const text = doc.querySelector("p")?.textContent || "";
        const imgSrc = doc.querySelector("img")?.getAttribute("src") || "";

        let facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(imgSrc)}`;
        if (text) {
            facebookUrl += `&quote=${encodeURIComponent(text)}`;
        }

        window.open(facebookUrl, "_blank");
    };

    navigateBlogDetails(BlogID) {
        this.props.navigate(`/blogDetails/${BlogID}`, { state: { BlogID: BlogID } })
    }

    truncateSpecificTags = (htmlContent, maxLength = 275) => {
        if (!htmlContent) return "";

        // Create a temporary DOM parser
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlContent, "text/html");

        // Find all <p> and <span> elements inside the HTML
        const targetElements = doc.querySelectorAll("p, span");

        targetElements.forEach((element) => {
            let textContent = element.textContent.trim();

            if (textContent.length > maxLength) {
                let truncatedText = textContent.substring(0, maxLength) + "...";

                // Preserve child elements inside <p> or <span>
                element.innerHTML = truncatedText;
            }
        });

        return doc.body.innerHTML; // Return modified HTML content
    }
    navigateApplyEvent(URL) {
        if (URL) {
            window.open(URL, '_blank');
        } else {
            toastError("Invalid URL");
        }
    }
    //cms
    async getCmsContent(MenuID, MenuUrl) {
        try {
            this.setState({ isLoading: true });

            // Remove leading '/' if present
            const formattedMenuUrl = MenuUrl?.startsWith('/') ? MenuUrl.substring(1) : MenuUrl;

            const data = await this.props.getCmsContent_action(MenuID ? MenuID : 1, formattedMenuUrl ? formattedMenuUrl : 'home');
            if (data.error !== 1) {
                this.setState({
                    isLoading: false,
                    cmsSectionData: data?.data[0] !== "" ? data?.data[0] : [],
                    cmsMenuData: data?.data[1] !== "" ? data?.data[1] : [],
                    cmsFooterData: data?.data[2][0] !== "" ? data?.data[2][0] : [],
                });
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
                if (data.msg == 'Page not found.') {
                    if (this.props.location.pathname.includes('cms/manage')) {
                        window.location.reload();
                        this.props.navigate('/cms/manage');
                    } else {
                        window.location.reload();
                        this.props.navigate('/');
                    }
                }
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }
    CustomNextArrow = (props) => {
        const { onClick } = props;
        return (
            <div onClick={onClick}
                style={{
                    position: 'absolute', right: '5px', top: '50%',
                    transform: 'translateY(-50%)', zIndex: 2,
                    cursor: 'pointer', color: 'black', fontSize: '24px',
                }}
            ><i class="fa fa-arrow-circle-o-right" aria-hidden="true"></i></div>
        );
    };

    CustomPrevArrow = (props) => {
        const { onClick } = props;
        return (
            <div onClick={onClick}
                style={{
                    position: 'absolute', left: '5px', top: '50%',
                    transform: 'translateY(-50%)', zIndex: 2,
                    cursor: 'pointer', color: 'black', fontSize: '24px',
                }}
            ><i class="fa fa-arrow-circle-o-left" aria-hidden="true"></i></div>
        );
    };

    render() {
        const { isLoading, downloadUrl, ServiceRelated, isOpen, timeLeft, popMsg, popDetails, blogList, eventMasterList, slideList,
            MenuID, cmsFooterData, cmsMenuData, cmsSectionData, isSiteMaintenance } = this.state
        const dynamicSettings = {
            dots: false,
            infinite: 1,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            autoplay: false,
            autoplaySpeed: 3000,
            nextArrow: <this.CustomNextArrow />,
            prevArrow: <this.CustomPrevArrow />,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: false,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: false,
                    },
                },
            ],
            beforeChange: (current, next) => this.handleAfterChange(next, dynamicSettings),
        };
        const settings = {
            dots: false,
            // infinite: eventMasterList.length > 1, // Only infinite if more than 1 slide
            infinite: 1,
            speed: 500,
            // slidesToShow: eventMasterList.length < 3 ? eventMasterList.length : 3,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            autoplay: false,
            autoplaySpeed: 3000,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: false,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: false,
                    },
                },
            ],
            beforeChange: (current, next) => this.handleAfterChange(next, settings),
        };

        return (

            <>
                {isLoading ? (<Loader />) : null}
                {!isLoading && <Header headerNavs={cmsMenuData} />}
                <div class="mouse-cursor cursor-outer"></div>
                <div class="mouse-cursor cursor-inner"></div>
                <>
                    {MenuID == 1 ? <>
                        {cmsSectionData?.length > 0 ? (
                            <>
                                {cmsSectionData
                                    .filter(section => section.isPublish && section.isactive)
                                    .sort((a, b) => a.SeqNo - b.SeqNo)
                                    .map((section, index) => (
                                        <>
                                            <section key={section.ContentID || index} className="p-0">
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: section.SectionContent,
                                                    }}
                                                />
                                            </section>
                                            {index === 0 && MenuID == 1 && eventMasterList.length > 0 && (
                                                <section className="wcu-section section-padding fix pb-5">
                                                    <div className="wcu-wrapper style2">
                                                        <div className="container">
                                                            <div className="row align-items-center mb-45">
                                                                <div className="col-xl-12 text-center">
                                                                    <div className="section-title mb-3 mb-xl-0">
                                                                        <div className="subtitle" style={{ display: "block" }}>
                                                                            <img src="assets/img/icon/arrowLeft_1.svg" alt="icon" /> <span> Events </span>
                                                                            <img src="assets/img/icon/arrowRight_1.svg" alt="icon" />
                                                                        </div>
                                                                        <h2 className="title">Upcoming Events</h2>
                                                                    </div>
                                                                    <p className="desc mb-3 mb-xl-0 text-center">
                                                                        {/* You can choose display Featured, Upcoming, Past, Creation Date here */}
                                                                    </p>
                                                                </div>
                                                            </div>

                                                            <div className="row gy-5">
                                                                <div className="col-lg-12" >
                                                                    <div className="slider-container" >
                                                                        <Slider {...dynamicSettings} className="slider1">
                                                                            {eventMasterList.map((item) => (
                                                                                <div className="slide mr-2 d-flex justify-content-center" key={item.EventID}>
                                                                                    <a href={item.URL} target="_blank" rel="noopener noreferrer">
                                                                                        <div className="event-image">
                                                                                            <img
                                                                                                src={`${downloadUrl + item.FilePath}`}
                                                                                                alt="Event"
                                                                                                style={{ height: '320px', margin: 'auto' }}
                                                                                            />
                                                                                        </div>
                                                                                    </a>
                                                                                    <div className={item.isActive ? 'event-content-active' : 'event-content'}>
                                                                                        <a href={item.URL} target="_blank" rel="noopener noreferrer">
                                                                                            <div className="event-title mb-10 text-center">
                                                                                                <h3 className="title">{item.Title}</h3>
                                                                                                <p className="title_details text-left">{item.Description}</p>
                                                                                                {item.PriceInr && (
                                                                                                    <span className="ticket-price">Tickets from {item.PriceInr}</span>
                                                                                                )}
                                                                                            </div>
                                                                                        </a>
                                                                                        <div className="event-post-meta ul-li-block mb-10">
                                                                                            <ul>
                                                                                                {item.Duration ? <>
                                                                                                    <li>
                                                                                                        <span className="icon"><i className="fa fa-clock"></i></span> {item.Duration}
                                                                                                    </li>
                                                                                                </> : <></>}
                                                                                                {item.Address ? <>
                                                                                                    <li>
                                                                                                        <span className="icon"><i className="fa fa-map-marker"></i></span> {item.Address}
                                                                                                    </li>
                                                                                                </> : <></>}
                                                                                                {item.Duration &&
                                                                                                    (() => {
                                                                                                        const startDate = new Date(item.EventFromDate);
                                                                                                        const endDate = new Date(item.EventToDate);
                                                                                                        const now = new Date();

                                                                                                        const hasEnded = now > endDate;

                                                                                                        if (hasEnded) return null; // hide everything if ended

                                                                                                        return (
                                                                                                            <li className="d-flex">
                                                                                                                {/* Show both if not ended */}
                                                                                                                <button
                                                                                                                    className="gt-btn style6"
                                                                                                                    style={{ padding: '10px', marginRight: '4px' }}
                                                                                                                    onClick={() => this.navigateEventEnquiry(item.EventID, 0)}
                                                                                                                >
                                                                                                                    Enquiry <i className="fa fa-arrow-right-long" />
                                                                                                                </button>

                                                                                                                {item.URL && (
                                                                                                                    <button
                                                                                                                        className="gt-btn style6"
                                                                                                                        style={{ padding: '10px' }}
                                                                                                                        onClick={() => this.navigateApplyEvent(item.URL)}
                                                                                                                    >
                                                                                                                        Apply Now <i className="fa fa-arrow-right-long" />
                                                                                                                    </button>
                                                                                                                )}
                                                                                                            </li>
                                                                                                        );
                                                                                                    })()
                                                                                                }

                                                                                            </ul>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </Slider>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </section>
                                            )}
                                        </>
                                    ))}

                            </>
                        ) : null}
                    </> : <>
                        {cmsSectionData?.length > 0 ? (
                            <>
                                {cmsSectionData
                                    .filter(section => section.isPublish && section.isactive)
                                    .sort((a, b) => a.SeqNo - b.SeqNo)
                                    .map((section, index) => (
                                        <section style={{ paddingTop: '165px' }} key={section.ContentID || index} className="p-0">
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: section.SectionContent,
                                                }}
                                            />
                                        </section>
                                    ))}
                            </>) : <>
                            <section style={{ paddingTop: '165px', textAlign: 'center' }}>
                                <p>No Records Found</p>
                            </section>
                        </>}
                    </>}
                </>
                {
                    MenuID == 1 && (
                        blogList?.length > 0 &&
                        <section class="blog-section fix">
                            <div class="blog-wrapper style1 section-padding pt-0">
                                <div class="container">
                                    <div class="row">
                                        <div class="col-12 d-flex justify-content-center">
                                            <div class="section-title title-area  mx-auto mb-50">
                                                <div class="subtitle d-flex justify-content-center"> <img src="assets/img/icon/arrowLeft_1.svg" alt="icon" /> <span> Blog & News
                                                </span><img src="assets/img/icon/arrowRight_1.svg" alt="icon" /></div>
                                                <h2 class="title text-center">Featured News And Insights</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row gy-5 gx-30">
                                        {blogList?.length > 0 && blogList.map((item) => (
                                            <div class="col-xl-4 col-md-6">
                                                <div class="blog-card style2 wow fadeInUp" data-wow-delay=".4s">
                                                    <div class="blog-card-thumb" style={{ height: '480px' }}>
                                                        <p className="m-1">
                                                            {/* <span dangerouslySetInnerHTML={{ __html: this.sanitizeAndResizeImages(item.Details) }} /> */}
                                                            {/* {console.log("item.Details-->",item.Details)} */}
                                                            <span
                                                                dangerouslySetInnerHTML={{
                                                                    __html: this.truncateSpecificTags(item.Details, 275),
                                                                }}
                                                            />
                                                        </p>
                                                    </div>
                                                    <div class="blog-card-body">
                                                        <h3><a style={{ color: '#744587' }}>{item.Title}</a></h3>
                                                        <div class="author-meta">
                                                            <div class="fancy-box style1">
                                                                <div class="item">
                                                                    <h6>{item.Name}</h6>
                                                                    <p>{item.Designation}</p>
                                                                </div>
                                                            </div>

                                                            <a class="link-btn style2"
                                                                onClick={() => this.navigateBlogDetails(item.BlogID)}
                                                            ><i
                                                                class="fa fa-arrow-right-long"></i></a>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}

                                    </div>
                                </div>
                            </div>
                        </section >
                    )
                }
                <Footer footerData={cmsFooterData} />
                <Modal show={isOpen} size="lg" >
                    <Modal.Body className="pb-2 pt-2"
                        style={{
                            backgroundColor: '#744587',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                        }}
                    >
                        <span
                            className="pop-close"
                            onClick={() => this.setState({ isOpen: false }, () => {
                                const { intervalId } = this.state;
                                if (intervalId) {
                                    clearInterval(intervalId); // Stop the timer
                                    this.setState({ intervalId: null }); // Reset the interval ID
                                }
                            })}
                        >
                            X
                        </span>
                        <div className="container text-center p-4">
                            <img
                                src="assets/img/logo_1.png"
                                alt="logo"
                                className="image timer-pop"
                            />
                            <h2 className="py-3 text-center com-soon-tag">Coming Soon</h2>
                            {popDetails != {} && <h5 className="pb-5 timer-pop-text com-soon">
                                The {popMsg} will start on {popDetails["date"]}<sup>{popDetails["pronounce"]}</sup> {popDetails["month"]} {popDetails["year"]} at {popDetails["time"]} noon (IST)
                            </h5>
                            }
                            {/* <h5 className="pt-3 pb-4 timer-pop-text com-soon">
                                The registration will be on first come first basis.
                            </h5> */}
                            <div className="countdown-out mt-5">
                                <div class="countdown">
                                    <div>
                                        <span id="days">{timeLeft.days}</span>
                                        <small>Days</small>
                                    </div>
                                    <div>
                                        <span id="hours">{timeLeft.hours}</span>
                                        <small>Hours</small>
                                    </div>
                                    <div>
                                        <span id="minutes">{timeLeft.minutes}</span>
                                        <small>Minutes</small>
                                    </div>
                                    <div>
                                        <span id="seconds">{timeLeft.seconds}</span>
                                        <small>Seconds</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
                {/* <section class="hero-section section-padding pb-0 fix">
                    <div class="hero-wrapper style2">
                        <div class="container">
                            <div class="hero-main-container style2 border-radius">
                                <div class="container">
                                    <div class="row">
                                        <div class="col-xl-6 order-2 order-xl-1">
                                            <div class="hero-content style2">
                                                <h1>Domestic & International Textile Engineering Industry</h1>
                                                <p class="text">ITME, has always been an initiator in shaping India's textile engineering industry through its various events, it has always served as a gateway event for new entrants in Indian and Asian textile markets.</p>
                                                <div class="contact-meta">
                                                    <div class="btn-wrapper">
                                                        <button class=" gt-btn style6"
                                                            onClick={() => {
                                                                this.handleRegisterNow()
                                                                // if (isCommingSoon) {
                                                                // } else {
                                                                //     this.getCountDownDate('/companyProfile')

                                                                // }
                                                            }}
                                                        >
                                                            REGISTER NOW <i className="fa fa-arrow-right-long" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6 order-1 order-xl-2 ">
                                            <div class="hero-thumb style2">
                                                <div class="video-box">
                                                    <a href="https://youtu.be/ag47pOihPx4" class="play-btn " target="_blank">
                                                        <img class="rotate360" src="assets/img/shape/heroShape2_1.png" alt="shape" />
                                                    </a>
                                                </div>

                                                <div class="main-thumb img-custom-anim-left wow fadeInUp" data-wow-delay=".3s">
                                                    <img src="assets/img/banner3.jpg" alt="thumb" />
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" style={{ position: 'absolute' }}>
                                    <clipPath id="heroMask2">
                                        <path
                                            d="M0 30C0 13.4315 13.4315 0 30 0H1830C1846.57 0 1860 13.4315 1860 30L1860 851C1860 867.569 1846.57 881 1830 881H1051.52C1033.75 881 1016.9 873.125 1005.5 859.495L955.737 800.005C944.337 786.375 927.483 778.5 909.714 778.5H30C13.4315 778.5 0 765.069 0 748.5V30Z"
                                            fill="#384BFF" />
                                    </clipPath>
                                </svg>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="wcu-section section-padding fix pb-5">
                    <div class="wcu-wrapper style2">
                        <div class="container">
                            <div class="row align-items-center mb-45">
                                <div class="col-xl-12 text-center">
                                    <div class="section-title mb-3 mb-xl-0">
                                        <div class="subtitle" style={{ display: "block" }}><img src="assets/img/icon/arrowLeft_1.svg" alt="icon" /> <span> Events </span><img src="assets/img/icon/arrowRight_1.svg" alt="icon" /></div>

                                        <h2 class="title">Upcoming Events</h2>
                                    </div>
                                </div>
                            </div>
                            <div className="row gy-5">
                                <div className="col-lg-12">
                                    <div className="slider-container">
                                        <style>
                                            {`
                                                .slick-list {
                                                padding-bottom: 90px
                                                }
                                                .slider1 .slick-track {
                                                display: flex;
                                                gap: 10px; 
                                                }
                                            `}
                                        </style>
                                        <div
                                            style={{
                                                // width: '100%',
                                                display: 'block'
                                            }}
                                        >
                                            <style>
                                                {`
                                                .slider-container {
                                                  text-align: center;
                                                  margin: 20px auto;
                                                  padding: 0 10px; 
                                                  max-width: 100%;
                                                }
                                                .button {
                                                  margin: 5px;
                                                  padding: 10px 15px;
                                                  background-color: #007bff;
                                                  color: white;
                                                  border: none;
                                                  border-radius: 5px;
                                                  cursor: pointer;
                                                  font-size: 16px;
                                                }
                                                .button:hover {
                                                  background-color: #0056b3;
                                                }
                                                .slick-prev:before, .slick-next:before {
                                                  color: black;
                                                }
                                                .slick-dots {
                                                  bottom: -30px; 
                                                }
                                                @media (max-width: 768px) {
                                                  .button {
                                                    font-size: 14px;
                                                    padding: 8px 12px;
                                                  }
                                                  .slider-container h2 {
                                                    font-size: 18px;
                                                  }
                                                }
                                            `}
                                            </style>
                                            {eventMasterList.length > 0 ? <>
                                                <Slider {...dynamicSettings} className='slider1'>
                                                    {eventMasterList.length > 0 && eventMasterList.map((item) => (<>
                                                        <div className="slide mr-2 d-flex justify-content-center" key={item.EventID}>
                                                            <a href={item.URL} target="_blank" rel="noopener noreferrer" >
                                                                <div class="event-image" >
                                                                    <img src={`${downloadUrl + item.FilePath}`} alt="Image_not_found" style={{ height: '320px', margin: 'auto' }} />
                                                                </div>
                                                            </a>
                                                            <div class={item.isActive ? 'event-content-active' : 'event-content'} >
                                                                <a href={item.URL} target="_blank" rel="noopener noreferrer" >
                                                                    <div class="event-title mb-10" style={{ textAlign: 'center' }}>
                                                                        <h3 class="title">
                                                                            {item.Title}
                                                                        </h3>
                                                                        <p class="title_details" style={{ textAlign: 'left' }}>{item.Description}</p>
                                                                        {item.PriceInr && <span class="ticket-price">Tickets from {item.PriceInr}</span>}
                                                                    </div>
                                                                </a>
                                                                <div class="event-post-meta ul-li-block mb-10">
                                                                    <ul>
                                                                        <li>
                                                                            <span class="icon">
                                                                                <i class="fa fa-clock"></i>
                                                                            </span>
                                                                            {item.Duration}
                                                                        </li>
                                                                        <li>
                                                                            <span class="icon">
                                                                                <i class="fa fa-map-marker "></i>
                                                                            </span>
                                                                            {item.Address}
                                                                        </li>
                                                                        <li className='d-flex'>
                                                                            <button class=" gt-btn style6" style={{ padding: '15px' }}
                                                                                onClick={() => {
                                                                                    this.navigateEventEnquiry(item.EventID, 0)
                                                                                }}
                                                                            >
                                                                                Enquiry <i className="fa fa-arrow-right-long" />
                                                                            </button>
                                                                            <button class=" gt-btn style6" style={{ padding: '15px' }} onclick={() => this.navigateApplyEvent(item.URL)}>
                                                                                Apply Now <i className="fa fa-arrow-right-long" />
                                                                            </button>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                    ))}
                                                </Slider>
                                            </> : <>
                                                <div className='text-center text-dark'>
                                                    No Events Available
                                                </div>
                                            </>}
                                        </div>
                                    </div>

                                </div>
                            </div>


                        </div>
                    </div >
                </section >
                <section class="about-section">
                    <div class="about-container-wrapper style2">
                        <div class="shape2  d-none d-xxl-block"><img src="assets/img/shape/aboutShape2_2.png" alt="shape" /></div>
                        <div class="container section-padding border-radius bg-common-color fix ">
                            <div class="about-title-container style1">
                                <div class="container">
                                    <div class="row d-flex align-items-center justify-content-between mb-60">
                                        <div class="col-xl-8">
                                            <div class="section-title mb-3 mb-lg-0">
                                                <div class="subtitle"> <img src="assets/img/icon/arrowLeft_1.svg" alt="icon" /> <span> About ITMES Trade Services</span><img src="assets/img/icon/arrowRight_1.svg" alt="icon" /></div>
                                                <h2 class="title mb-20">Facilitator of the right business connections for the growth of trade & economy</h2>
                                                <p class="text">India ITME Society with its 40 plus years heritage has embarked on a journey to strengthen the domestic and international textile engineering industry by facilitating multiple platforms for trade and business enhancement along with exchange of knowledge, technology transfer & encouraging Foreign Direct Investments & Joint Ventures in the textile industry, etc.
                                                </p>
                                            </div>
                                        </div>

                                        <div class="col-xl-4 d-flex justify-content-start justify-content-md-end">
                                            <div class="btn-wrapper" data-wow-delay=".9s">
                                                <a class="gt-btn" onClick={() => this.props.navigate('/itmeTradeServices')}> Read more <i class="fa fa-arrow-right-long"></i></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="">
                                <div class="container">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="about-thumb img-custom-anim-right wow fadeInUp" data-wow-delay=".3s">
                                                <img src="assets/img/about_img.jpg" alt="thumb" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="about-section space fix about_itme_2026">
                    <div className="about-container-wrapper style1">
                        <div className="shape1">
                            <img src="assets/img/aboutShape1_1.png" alt="shape" />
                        </div>
                        <div className="shape2">
                            <img src="assets/img/aboutShape1_2.png" alt="shape" />
                        </div>
                        <div className="shape3">
                            <img src="assets/img/aboutShape1_3.png" alt="shape" />
                        </div>
                        <div className="container">
                            <div className="row gy-5 gx-70">
                                <div className="col-xl-6">
                                    <div className="about-thumb">
                                        <div className="thumb1">
                                            <img
                                                className="img-custom-anim-left wow fadeInUp"
                                                data-wow-delay=".5s"
                                                src="assets/img/aboutThumb1_11_2.png"
                                                alt="thumb"
                                            />
                                        </div>
                                        <div className="thumb2">
                                            <img
                                                className="img-custom-anim-top wow fadeInUp"
                                                data-wow-delay=".8s"
                                                src="assets/img/aboutThumb1_21.png"
                                                alt="thumb"
                                            />
                                        </div>

                                    </div>
                                </div>
                                <div className="col-xl-6">
                                    <div className="about-content">
                                        <div className="section-title mxw-560">
                                            <div
                                                className="subtitle text-white wow fadeInUp"
                                                data-wow-delay=".3s"
                                                style={{
                                                    visibility: "visible",
                                                    animationDelay: "0.3s",
                                                    animationName: "fadeInUp"
                                                }}
                                            >
                                                {" "}
                                                <img src="assets/img/icon/arrowLeftWhite.svg" alt="icon" />{" "}
                                                <span className="text-white"> About India ITME Society</span>
                                                <img src="assets/img/icon/arrowRightWhite.svg" alt="icon" />
                                            </div>
                                           
                                            <p className="mt-25 text-white wow fadeInUp" data-wow-delay=".5s">
                                                India International Textile Machinery Exhibitions Society (India
                                                ITME Society), a 45 year old non-profit apex industry body,
                                                established in 1980, to support and serve the Textile
                                                Engineering Industry through Exhibitions &amp; Events.{" "}
                                            </p>
                                            <p className="text-white">
                                                The organisation and its team works relentlessly towards its
                                                Mission to aid, stimulate, promote, encourage &amp; support
                                                trade and commerce with a focus on Textile Engineering and
                                                allied industries, thus propagating the cause of Textile
                                                Engineering Industry at National and International levels.
                                            </p>
                                            <p className="text-white">
                                                India ITME Society today organizes exhibitions every year,
                                                addressing different requirements of the industry segment under
                                                its banner.{" "}
                                            </p>
                                        </div>
                                        <div className="fancy-box-wrapper style2">
                                            <div
                                                className="fancy-box style2 wow fadeInUp"
                                                data-wow-delay=".3s"
                                            >
                                                <div className="item">
                                                    <h6>
                                                        India International Textile Machinery Exhibition{" "}
                                                        <strong>(INDIA ITME)</strong> - Flagship event since 1980
                                                        completing 44 years
                                                    </h6>
                                                </div>
                                            </div>
                                            <div
                                                className="fancy-box style2 wow fadeInUp"
                                                data-wow-delay=".5s"
                                            >
                                                <div className="item">
                                                    <h6>
                                                        Global Textile Technology &amp; engineering show{" "}
                                                        <strong>(GTTES)</strong> - Focused on SME sector and
                                                        regional hubs
                                                    </h6>
                                                </div>
                                            </div>
                                            <div
                                                className="fancy-box style2 wow fadeInUp"
                                                data-wow-delay=".3s"
                                            >
                                                <div className="item">
                                                    <h6>
                                                        International Technology, Machinery &amp; Engineering
                                                        Exhibition <strong>(ITME AFRICA &amp; MIDDLE EAST)</strong>{" "}
                                                        (overseas edition).
                                                    </h6>
                                                </div>
                                            </div>
                                            <div
                                                className="fancy-box style2 wow fadeInUp"
                                                data-wow-delay=".5s"
                                            >
                                                <div className="item">
                                                    <h6>
                                                        India ITME Virtual Buyer Seller Meet{" "}
                                                        <strong>(ITME Virtual BSM)</strong>
                                                    </h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="whyattend">
                    <div className="left-gradient" />
                    <div className="row">
                        <div className="col-xl-2 col-lg-3 ps-xl-3 why-attend-section">
                            <h2 className="section-heading">
                                <div className="star">
                                    <img
                                        className="star-img"
                                        src="https://www.indiadigitalsummit.in/wp-content/themes/IDS/assets/images/star.png"
                                        width={60}
                                    />
                                </div>
                                Why Register
                            </h2>
                            </div>
                        <div className="col-xl-10 col-lg-9">

                            <div className="row">
                                <div className="col-xxl-3 col-lg-3 col-md-6">
                                    <div className="whyregister_card style2">
                                        <div className="icon">
                                            <img
                                                src="assets\img\whyregister\whyregisterIcon11.png"
                                                alt="icon"
                                            />
                                        </div>
                                        <div className="body">
                                            <h5>Knowledge sharing and capacity building</h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-lg-3 col-md-6">
                                    <div className="whyregister_card style2">
                                        <div className="icon">
                                            <img
                                                src="assets\img\whyregister\whyregisterIcon12.png"
                                                alt="icon"
                                            />
                                        </div>
                                        <div className="body">
                                            <h5>Enhanced visibility in international markets</h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-lg-3 col-md-6">
                                    <div className="whyregister_card style2">
                                        <div className="icon">
                                            <img
                                                src="assets\img\whyregister\whyregisterIcon13.png"
                                                alt="icon"
                                            />
                                        </div>
                                        <div className="body">
                                            <h5>Exclusive participation in trade missions</h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-lg-3 col-md-6">
                                    <div className="whyregister_card style2">
                                        <div className="icon">
                                            <img
                                                src="assets\img\whyregister\whyregisterIcon14.png"
                                                alt="icon"
                                            />
                                        </div>
                                        <div className="body">
                                            <h5>
                                                Opportunity to participate in exclusive international
                                                exhibitions
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="right-gradient" />
                </section>
                <section class="service-section section-padding fix">
                    <div class="container">
                        <div class="row d-flex align-items-center mb-45">
                            <div class="col-xl-4">
                                <div class="section-title mxw-560 mb-3 mb-xl-0">
                                    <div class="subtitle"> <img src="assets/img/icon/arrowLeft_1.svg" alt="icon" /> <span> Our services
                                    </span><img src="assets/img/icon/arrowRight_1.svg" alt="icon" /></div>
                                    <h2 class="title">Amazing Trade Services</h2>
                                </div>
                            </div>
                            <div class="col-xl-8">
                                <p class="desc  mb-3 mb-xl-0">India’s textiles sector is one of the oldest industries in the Indian economy, dating back to several centuries. The industry is extremely varied, with hand-spun and hand-woven textiles sectors at one end of the spectrum, with the capital-intensive sophisticated mills sector at the other end.</p>
                            </div>
                        </div>

                        <div class="row gy-5">
                            <div class="col-xxl-3 col-lg-4 col-md-6">
                                <div class="service-card style2">
                                    <div class="icon">
                                        <img src="assets/img/icon/serviceIcon1_1_1.svg" alt="icon" />
                                    </div>
                                    <div class="body">
                                        <h3> <a >Trade Missions</a> </h3>
                                        <p>Our trade missions provide members with opportunities to explore new markets and build international relationships.</p>
                                        <a class="link-btn style1" onClick={() => this.props.navigate('/tradeMission')}>Read more</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xxl-3 col-lg-4 col-md-6">
                                <div class="service-card style2">
                                    <div class="icon">
                                        <img src="assets/img/icon/serviceIcon1_2_1.svg" alt="icon" />
                                    </div>
                                    <div class="body">
                                        <h3> <a >Trade Enquiry</a> </h3>
                                        <p>Our trade enquiry service connects members with potential business opportunities.</p>
                                        <a class="link-btn style1" onClick={() => this.props.navigate('/tradeEnquiry')}>Read more </a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xxl-3 col-lg-4 col-md-6">
                                <div class="service-card style2">
                                    <div class="icon">
                                        <img src="assets/img/icon/serviceIcon1_3_1.svg" alt="icon" />
                                    </div>
                                    <div class="body">
                                        <h3> <a >International Exhibition</a> </h3>
                                        <p>We secure pavilions at leading international exhibitions, offering Indian businesses the opportunity to exhibit globally.</p>
                                        <a class="link-btn style1" onClick={() => this.props.navigate('/internationalExhibitions')}>Read more </a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xxl-3 col-lg-4 col-md-6">
                                <div class="service-card style2">
                                    <div class="icon">
                                        <img src="assets/img/icon/serviceIcon1_3_1.svg" alt="icon" />
                                    </div>
                                    <div class="body">
                                        <h3> <a >Knowledge Sessions</a> </h3>
                                        <p>Staying informed and up-to-date with the latest industry trends and developments is crucial for business success.</p>
                                        <a class="link-btn style1" onClick={() => this.props.navigate('/knowledgeSessions')}>Read more </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section >
                <section className="work-process-section">
                    <div className="work-process-container-wrapper style2 pb-0 pb-xl-5 bg-transparent">
                       
                        <div className="container">
                            <div className="work-process-wrapper style2 section-padding fix border-radius bg-theme-color">
                                <div className="shape1">
                                    <img src="assets/img/shape/workProcessShape2_1.png" alt="shape" />
                                </div>
                                <div className="shape2">
                                    <img src="assets/img/shape/workProcessShape2_2.png" alt="shape" />
                                </div>
                                <div className="container">
                                    <div className="row gy-5 gx-70">
                                        <div className="col-xl-6">
                                            <div className="work-process-content">
                                                <div className="section-title mxw-560">
                                                    <div
                                                        className="subtitle text-white wow fadeInUp"
                                                        data-wow-delay=".3s"
                                                    >
                                                        {" "}
                                                        <img src="assets/img/icon/arrowLeftWhite.svg" alt="icon" />
                                                        <span className="text-white"> Practices</span>
                                                        <img src="assets/img/icon/arrowRightWhite.svg" alt="icon" />
                                                    </div>
                                                    <h2
                                                        className="title text-white wow fadeInUp"
                                                        data-wow-delay=".6s"
                                                    >
                                                        ITME Trade Practices for Stakeholders
                                                    </h2>
                                                    <p
                                                        className="mt-25 mb-50 text-white wow fadeInUp"
                                                        data-wow-delay=".5s"
                                                    >
                                                        ITME is always on the verge of bringing more and more for
                                                        the betterment of the textile ecosystem and overall growth
                                                        of the textile industry.
                                                    </p>
                                                   
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-6">
                                            <div
                                                className="work-process-thumb img-custom-anim-left wow fadeInUp"
                                                data-wow-delay=".3s"
                                            >
                                                <div className="thumb2_1">
                                                    <img src="assets/img/process_img.png" alt="thumb" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </section>
                <section className="faq-section-2 fix section-padding pb-3">
                    <div className="container">
                        <div className="faq-wrapper">
                            <div className="row g-4">
                                <div className="col-lg-6 wow fadeInUp" data-wow-delay=".4s">
                                    <div className="faq-image">
                                        <img src="assets/img/faq_img.png" alt="faq-img" />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="faq-content style2">
                                        <div className="section-title mb-40 mxw-650">
                                            <div className="subtitle">
                                                {" "}
                                                <img src="assets/img/icon/arrowLeft.svg" alt="icon" />{" "}
                                                <span> See Our Faqs</span>
                                                <img src="assets/img/icon/arrowRight.svg" alt="icon" />
                                            </div>
                                            <h2 className="title"> Service-Related Queries </h2>
                                        </div>
                                        <div className="faq_dropdown mb-3">
                                            <select className="form-control"
                                                value={ServiceRelated}
                                                onChange={(e) => this.setState({ ServiceRelated: e.target.value })}
                                            >
                                                <option value={0}>-- Select --</option>
                                                <option value="Trade_Missions">Trade Missions</option>
                                                <option value="Trade_Enquiry">Trade Enquiry</option>
                                                <option value="Knowledge_Session">Knowledge Session</option>
                                                <option value="International_Exhibitions">
                                                    International Exhibitions
                                                </option>
                                            </select>
                                        </div>
                                        {ServiceRelated == 'Trade_Missions' &&
                                            <div id="Trade_Missions">
                                                <div className="faq-accordion mt-4 mt-md-0">
                                                    <div className="accordion" id="accordion">
                                                        <div className="accordion-item mb-3">
                                                            <h5 className="accordion-header">
                                                                <button
                                                                    className="accordion-button"
                                                                    type="button"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#Trade_Missions_faq1"
                                                                    aria-expanded="false"
                                                                    aria-controls="Trade_Missions_faq1"
                                                                >
                                                                    Where is the upcoming trade mission?
                                                                </button>
                                                            </h5>
                                                            <div
                                                                id="Trade_Missions_faq1"
                                                                className="accordion-collapse show"
                                                                data-bs-parent="#accordion"
                                                            >
                                                                <div className="accordion-body">
                                                                    The location of our upcoming trade mission varies based
                                                                    on market opportunities. We conduct both inbound and
                                                                    outbound trade missions across key global markets. For
                                                                    detailed information on the next mission, please refer
                                                                    to our Trade mission section (Link of the website
                                                                    section) or contact our team.
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="accordion-item mb-3">
                                                            <h5 className="accordion-header">
                                                                <button
                                                                    className="accordion-button collapsed"
                                                                    type="button"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#Trade_Missions_faq2"
                                                                    aria-expanded="false"
                                                                    aria-controls="Trade_Missions_faq2"
                                                                >
                                                                    What are the benefits of attending the mission?
                                                                </button>
                                                            </h5>
                                                            <div
                                                                id="Trade_Missions_faq2"
                                                                className="accordion-collapse collapse"
                                                                data-bs-parent="#accordion"
                                                            >
                                                                <div className="accordion-body">
                                                                    By attending a trade mission, participants gain direct
                                                                    access to potential business partners, industry
                                                                    insights, and networking opportunities in new markets.
                                                                    The missions also provide valuable exposure to emerging
                                                                    trends, government policies, and business landscapes,
                                                                    helping companies explore new ventures and expand
                                                                    globally.
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="accordion-item mb-3">
                                                            <h5 className="accordion-header">
                                                                <button
                                                                    className="accordion-button collapsed"
                                                                    type="button"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#Trade_Missions_faq3"
                                                                    aria-expanded="false"
                                                                    aria-controls="Trade_Missions_faq3"
                                                                >
                                                                    What are the objectives of the upcoming Trade Mission?
                                                                </button>
                                                            </h5>
                                                            <div
                                                                id="Trade_Missions_faq3"
                                                                className="accordion-collapse collapse"
                                                                data-bs-parent="#accordion"
                                                            >
                                                                <div className="accordion-body">
                                                                    The primary objectives of our trade missions are to
                                                                    facilitate business collaborations, foster partnerships,
                                                                    and provide a platform for companies to explore new
                                                                    markets in a sorted manner. We aim to help businesses
                                                                    engage with potential buyers, distributors, and industry
                                                                    stakeholders while gaining first-hand knowledge of
                                                                    international market dynamics.
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {ServiceRelated == 'Trade_Enquiry' &&
                                            <div id="Trade_Enquiry">
                                                <div className="faq-accordion mt-4 mt-md-0">
                                                    <div className="accordion" id="accordion">
                                                        <div className="accordion-item mb-3">
                                                            <h5 className="accordion-header">
                                                                <button
                                                                    className="accordion-button"
                                                                    type="button"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#Trade_Enquiry_faq1"
                                                                    aria-expanded="false"
                                                                    aria-controls="Trade_Enquiry_faq1"
                                                                >
                                                                    What type of business opportunities are available?
                                                                </button>
                                                            </h5>
                                                            <div
                                                                id="Trade_Enquiry_faq1"
                                                                className="accordion-collapse show"
                                                                data-bs-parent="#accordion"
                                                            >
                                                                <div className="accordion-body">
                                                                    We offer a wide range of business opportunities,
                                                                    including joint ventures, sourcing services, investment
                                                                    partnerships, and distribution collaborations. These
                                                                    opportunities are tailored to support growth in the
                                                                    textile machinery sector and related industries.
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="accordion-item mb-3">
                                                            <h5 className="accordion-header">
                                                                <button
                                                                    className="accordion-button collapsed"
                                                                    type="button"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#Trade_Enquiry_faq2"
                                                                    aria-expanded="false"
                                                                    aria-controls="Trade_Enquiry_faq2"
                                                                >
                                                                    Are the business opportunities just national or also
                                                                    international?
                                                                </button>
                                                            </h5>
                                                            <div
                                                                id="Trade_Enquiry_faq2"
                                                                className="accordion-collapse collapse"
                                                                data-bs-parent="#accordion"
                                                            >
                                                                <div className="accordion-body">
                                                                    Our trade services provide both national and
                                                                    international business opportunities. We connect members
                                                                    with global markets, helping them explore partnerships
                                                                    and business growth across India as well as in key
                                                                    international markets.
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="accordion-item mb-3">
                                                            <h5 className="accordion-header">
                                                                <button
                                                                    className="accordion-button collapsed"
                                                                    type="button"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#Trade_Enquiry_faq3"
                                                                    aria-expanded="false"
                                                                    aria-controls="Trade_Enquiry_faq3"
                                                                >
                                                                    What sector or industry are you primarily focused on?
                                                                </button>
                                                            </h5>
                                                            <div
                                                                id="Trade_Enquiry_faq3"
                                                                className="accordion-collapse collapse"
                                                                data-bs-parent="#accordion"
                                                            >
                                                                <div className="accordion-body">
                                                                    We specialize in the textile machinery sector
                                                                    (accessories, media, logistics, IT &amp; design services
                                                                    for textile). However, our services cater to businesses
                                                                    that are involved in related industries such as
                                                                    textiles, engineering, and manufacturing, offering them
                                                                    avenues to expand and explore new opportunities.
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {ServiceRelated == 'Knowledge_Session' &&
                                            <div id="Knowledge_Session">
                                                <div className="faq-accordion mt-4 mt-md-0">
                                                    <div className="accordion" id="accordion">
                                                        <div className="accordion-item mb-3">
                                                            <h5 className="accordion-header">
                                                                <button
                                                                    className="accordion-button"
                                                                    type="button"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#Knowledge_Session_faq1"
                                                                    aria-expanded="false"
                                                                    aria-controls="Knowledge_Session_faq1"
                                                                >
                                                                    Are the knowledge sessions online or offline?
                                                                </button>
                                                            </h5>
                                                            <div
                                                                id="Knowledge_Session_faq1"
                                                                className="accordion-collapse show"
                                                                data-bs-parent="#accordion"
                                                            >
                                                                <div className="accordion-body">
                                                                    Our knowledge sessions are conducted both online and
                                                                    offline, depending on the topic and the audience's
                                                                    preference. We offer webinars for remote participation
                                                                    as well as in-person events for those who prefer
                                                                    face-to-face interaction.
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="accordion-item mb-3">
                                                            <h5 className="accordion-header">
                                                                <button
                                                                    className="accordion-button collapsed"
                                                                    type="button"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#Knowledge_Session_faq2"
                                                                    aria-expanded="false"
                                                                    aria-controls="Knowledge_Session_faq2"
                                                                >
                                                                    How are the topics of the session selected?
                                                                </button>
                                                            </h5>
                                                            <div
                                                                id="Knowledge_Session_faq2"
                                                                className="accordion-collapse collapse"
                                                                data-bs-parent="#accordion"
                                                            >
                                                                <div className="accordion-body">
                                                                    The topics for our knowledge sessions are selected based
                                                                    on current industry trends, member feedback, and key
                                                                    developments in the global market. We ensure that each
                                                                    session addresses relevant challenges and opportunities
                                                                    for businesses in the textile machinery and related
                                                                    sectors.
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="accordion-item mb-3">
                                                            <h5 className="accordion-header">
                                                                <button
                                                                    className="accordion-button collapsed"
                                                                    type="button"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#Knowledge_Session_faq3"
                                                                    aria-expanded="false"
                                                                    aria-controls="Knowledge_Session_faq3"
                                                                >
                                                                    How frequently are the knowledge sessions conducted?
                                                                </button>
                                                            </h5>
                                                            <div
                                                                id="Knowledge_Session_faq3"
                                                                className="accordion-collapse collapse"
                                                                data-bs-parent="#accordion"
                                                            >
                                                                <div className="accordion-body">
                                                                    We conduct knowledge sessions regularly throughout the
                                                                    year. The frequency depends on market demands and
                                                                    industry updates, ensuring participants are
                                                                    well-informed on the latest developments.
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {ServiceRelated == 'International_Exhibitions' &&
                                            <div id="International_Exhibitions">
                                                <div className="faq-accordion mt-4 mt-md-0">
                                                    <div className="accordion" id="accordion">
                                                        <div className="accordion-item mb-3">
                                                            <h5 className="accordion-header">
                                                                <button
                                                                    className="accordion-button"
                                                                    type="button"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#International_Exhibitions_faq1"
                                                                    aria-expanded="false"
                                                                    aria-controls="International_Exhibitions_faq1"
                                                                >
                                                                    Which all exhibitions are available for participation?
                                                                </button>
                                                            </h5>
                                                            <div
                                                                id="International_Exhibitions_faq1"
                                                                className="accordion-collapse show"
                                                                data-bs-parent="#accordion"
                                                            >
                                                                <div className="accordion-body">
                                                                    We facilitate participation in a range of international
                                                                    exhibitions across major markets such as Europe, Asia,
                                                                    and Africa. Please refer to our events section for the
                                                                    full list of upcoming exhibitions opportunities.
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="accordion-item mb-3">
                                                            <h5 className="accordion-header">
                                                                <button
                                                                    className="accordion-button collapsed"
                                                                    type="button"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#International_Exhibitions_faq2"
                                                                    aria-expanded="false"
                                                                    aria-controls="International_Exhibitions_faq2"
                                                                >
                                                                    What are the benefits of participating through ITMES
                                                                    Trade Services?
                                                                </button>
                                                            </h5>
                                                            <div
                                                                id="International_Exhibitions_faq2"
                                                                className="accordion-collapse collapse"
                                                                data-bs-parent="#accordion"
                                                            >
                                                                <div className="accordion-body">
                                                                    Participating through our trade services allows you to
                                                                    access premium pavilions. Under the India Pavilion, we
                                                                    can showcase all Indian companies under one roof,
                                                                    significantly increasing visibility and offering a
                                                                    unified representation in international markets. This
                                                                    collective presence enhances the prominence of Indian
                                                                    businesses.
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="accordion-item mb-3">
                                                            <h5 className="accordion-header">
                                                                <button
                                                                    className="accordion-button collapsed"
                                                                    type="button"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#International_Exhibitions_faq3"
                                                                    aria-expanded="false"
                                                                    aria-controls="International_Exhibitions_faq3"
                                                                >
                                                                    Which is the upcoming international exhibition
                                                                    opportunity?
                                                                </button>
                                                            </h5>
                                                            <div
                                                                id="International_Exhibitions_faq3"
                                                                className="accordion-collapse collapse"
                                                                data-bs-parent="#accordion"
                                                            >
                                                                <div className="accordion-body">
                                                                    The upcoming international exhibition opportunity are
                                                                    selected on demand basis of the members. Please stay
                                                                    tuned to our website and subscribe to our mailing list
                                                                    to receive updates on the next international exhibition
                                                                    you can participate in.
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <div className="contact-form-section section-padding fix">
                    <div className="container-fluid">
                        <div className="contact-title-wrapper pb-425 bg-theme-color section-padding border-radius">
                            <div className="container">
                                <div className="row">
                                    <div className="col-xl-7">
                                        <div className="section-title mb-3 mb-xl-0">
                                            <div className="subtitle text-white">
                                                {" "}
                                                <img src="assets/img/icon/arrowLeftWhite.svg" alt="icon" />
                                                <span className="text-white"> Enquiry Now</span>
                                                <img src="assets/img/icon/arrowRightWhite.svg" alt="icon" />
                                            </div>
                                            <h2 className="title text-white">
                                                Secure your spot now and be a part of the most unforgettable
                                                event of the year.
                                            </h2>
                                        </div>
                                    </div>
                                    <div className="col-xl-5 text-right">
                                        <a className="gt-btn style5"
                                            onClick={() => {
                                                this.props.navigate('/enquiryForm');
                                                // if (isCommingSoon) {
                                                // } else {
                                                //     this.getEnquiryDate('/enquiryForm')
                                                // }
                                            }}
                                        >
                                            {" "}
                                            Enquire Now <i className="fa fa-arrow-right-long" />
                                        </a>
                                        <div
                                            className="fancy-box-wrapper style4 text-center wow fadeInUp"
                                            data-wow-delay=".9s"
                                        >
                                            <div
                                                className="fancy-box style4"
                                                style={{ visibility: "hidden" }}
                                            >
                                                <div className="title">
                                                    <img src="assets/img/icon/starIcon1_1.svg" alt="icon" />{" "}
                                                    Trustipilot
                                                </div>
                                                <div className="item-wrap">
                                                    <div className="item">
                                                        <img
                                                            src="assets/img/shape/profileShape1_1.png"
                                                            alt="shape"
                                                        />
                                                    </div>
                                                    <div className="item">
                                                        <div className="star-wrapper">
                                                            <img src="assets/img/icon/starIcon1_2.svg" alt="icon" />
                                                            <img src="assets/img/icon/starIcon1_2.svg" alt="icon" />
                                                            <img src="assets/img/icon/starIcon1_2.svg" alt="icon" />
                                                        </div>
                                                        <h6>450+ reviews</h6>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                className="fancy-box style4 border-0"
                                                style={{ visibility: "hidden" }}
                                            >
                                                <div className="title"> Google</div>
                                                <div className="item-wrap">
                                                    <div className="item">
                                                        <img
                                                            src="assets/img/shape/profileShape1_1.png"
                                                            alt="shape"
                                                        />
                                                    </div>
                                                    <div className="item">
                                                        <div className="star-wrapper">
                                                            <img src="assets/img/icon/starIcon1_2.svg" alt="icon" />
                                                            <img src="assets/img/icon/starIcon1_2.svg" alt="icon" />
                                                            <img src="assets/img/icon/starIcon1_2.svg" alt="icon" />
                                                        </div>
                                                        <h6>450+ reviews</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="contact-form-wrapper style1 mt-n368 ">
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="contact-map style2">
                                        <iframe
                                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4683.297095154223!2d72.82183117596294!3d18.924418156712257!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7d1eec807af1b%3A0x2addede9776ec83!2sIndia%20ITME%20Society!5e1!3m2!1sen!2sin!4v1738059459910!5m2!1sen!2sin"
                                            style={{ width: "100%", height: 587 }}
                                            allowFullScreen=""
                                            loading="lazy"
                                            referrerPolicy="no-referrer-when-downgrade"
                                        />
                                        <div className="contact-info-wrapper style2">
                                            <h2>Contact Info</h2>
                                            <div className="shape-left">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width={29}
                                                    height={39}
                                                    viewBox="0 0 29 39"
                                                    fill="none"
                                                >
                                                    <path d="M0 0L29 39V0H0Z" fill="#744587" />
                                                </svg>
                                            </div>
                                            <div className="shape-right">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width={29}
                                                    height={39}
                                                    viewBox="0 0 29 39"
                                                    fill="none"
                                                >
                                                    <path d="M29 0L0 39V0H29Z" fill="#744587" />
                                                </svg>
                                            </div>
                                            <div className="contact-info style2">
                                                <div className="icon">
                                                    <i class="fa fa-map-marker" aria-hidden="true"></i>
                                                </div>
                                                <div className="content">
                                                    <h3>
                                                        India ITME Society,
                                                        <br />
                                                        1210/1211/1212 Dalamal Tower, ‘A’ Wing, 12th Floor, Plot
                                                        No.211, Nariman Point, Mumbai – 400 021, INDIA
                                                    </h3>
                                                </div>
                                            </div>
                                            <div className="contact-info style2">
                                                <div className="icon">
                                                    <i className="fa fa-phone" />
                                                </div>
                                                <div className="content">
                                                    <h3>
                                                        <a href="tel:+912249724603">+91-22-4972 4603</a>
                                                    </h3>
                                                </div>
                                            </div>
                                            <div className="contact-info style2 border-none">
                                                <div className="icon">
                                                    <i className="fa fa-envelope" />
                                                </div>
                                                <div className="content">
                                                    <h3>
                                                        <a href="mailto:itme@india-itme.com">itme@india-itme.com</a>
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}


            </>
        )

    }
}
// ReactDOM.render(<Homepage />, document.querySelector('.demo-carousel'))

export default withRouter(connect(null, { countDownDate_action, getWebsiteBlogList_action, get_eventMaster_list_action, getCmsContent_action })(Homepage));